import { useParams } from "react-router-dom";
import { LinearLoader } from "../../../../components/linear-loader/LinearLoader.jsx";
import { useLoadEndUserFullData } from "../hooks/useLoadEndUserFullData.js";

export const SingleEndUserGuard = ({ children }) => {
    const { endUserId } = useParams()
    const { data } = useLoadEndUserFullData(endUserId)
    return data ? children : <LinearLoader />
}
